import type { Theme } from "@mui/material/styles";
import type { PaletteShadeMap } from "types/theme";

/**
 * Type-safe accessor for numeric palette shades (e.g. `primary[200]`).
 *
 * Only colors and shades that are actually defined in
 * `src/themes/tokens/light.ts` and `src/themes/tokens/dark.ts` (and declared
 * in `PaletteShadeMap`) are accepted, so the return type is a definite
 * `string` rather than `string | undefined`.
 *
 * @example
 *   const bg = paletteShade(theme, "primary", 200);
 */
export const paletteShade = <
  C extends keyof PaletteShadeMap,
  S extends keyof PaletteShadeMap[C]
>(
  theme: Theme,
  color: C,
  shade: S
): string =>
  (theme.vars.palette[color] as unknown as PaletteShadeMap[C])[shade] as string;
